import { DateTime } from 'luxon';

// src/helpers/factories/customers/cardInfoTableFactory.ts
var cardInfoTableFactory = (cards) => Object.values(cards || {}).map((card) => {
  return {
    id: card.cardId,
    isDefault: card.isDefault,
    lastFourDigits: `**** **** **** ${card.lastFourDigits}`,
    cardType: card.cardType,
    dateOfLastUsed: DateTime.fromISO(card.dateOfLastUsed).toFormat(
      "MM/dd/yy"
    )
  };
});

export { cardInfoTableFactory };
